// Application types

const CATALOGUE = {
  LOADING_CATALOGUE: "LOADING_CATALOGUE",
  ALL_CATALOGUES: "ALL_CATALOGUES",
  SINGLE_CATALOGUE: "SINGLE_CATALOGUE",
};

export default CATALOGUE;
